import React from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import { CopyToClipboard } from "@_common/text-helpers";
import "./email-log.scss";
import { convertCurrentDateWithTime } from "@_common/date-helpers";

function EmailLogViewPopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    request,
    handleChangeText,
    editorState,
    onEditorStateChange,
    submitLoading,
    handleSubmit,
    editInfo,
    setRequest,
  } = props;
  return (
    <>
      <div
        className={`compelte-task-wrapper ${
          showUpdatePopup ? "compelte-task-wrapper--active" : ""
        }`}
      >
        <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
          <h6 className="compelte-task-wrapper__title">View Email Logs</h6>
          <img
            src="/images/close-white.svg"
            className="img-fluid navigation-bar-wrapper__close-btn"
            onClick={() => {
              setShowUpdatePopup(false);
            }}
          />
        </div>

        {/* <div className="compelte-task-wrapper__body d-flex h-100"></div> */}
        <div className="d-flex max-height-mail-template email-template-wrapper">
          <div className="user-details-wrapper m-0 email-template-editable-content-holder w-100">
            <div className="email-template-editable-content">
              <div className="checkpoint-active-details-wrapper__form-wrapper">
                <div className="checkpoint-active-details-wrapper__form-content_email_template view-email-logs-popup mw-100">
                  <div className="sent-on-wrap">
                    <span>
                      {convertCurrentDateWithTime(
                        getValue(props, `editInfo.createdAt`, "")
                      )}
                    </span>
                  </div>

                  {/* <h4 className="mt-3 mb-3">New task assigned)</h4> */}
                  <div className="w-100">
                    <div className="mt-0 form-group">
                      <label className="checkpoint-active-details__label">
                        Receipients
                      </label>
                      <div className="val-holder">
                        {getValue(props, `editInfo.recipients`, []).map(
                          (item: any) => {
                            return <div>{item}</div>;
                          }
                        )}
                      </div>
                    </div>

                    <div className="border_bottom view_emaillogs_seperator"></div>

                    {getValue(props, `editInfo.ccrecipients`, []) && (
                      <>
                        <div className="mt-0 form-group">
                          <label className="checkpoint-active-details__label">
                            CC
                          </label>
                          <div className="val-holder">
                            {getValue(props, `editInfo.ccrecipients`, []).map(
                              (item: any) => {
                                return <div>{item}</div>;
                              }
                            )}
                          </div>
                        </div>

                        <div className="border_bottom view_emaillogs_seperator"></div>
                      </>
                    )}

                    <div className="user-details-wrapper__form-group form-group">
                      <label className="checkpoint-active-details__label">
                        Subject
                      </label>
                      <div className="val-holder">
                        {getValue(props, `editInfo.subject`, "")}
                      </div>
                    </div>
                  </div>

                  <div className="border_bottom view_emaillogs_seperator"></div>

                  <div className="user-details-wrapper__form-group form-group">
                    {/* <div className="d-flex justify-content-between">
                      <label className="checkpoint-active-details__label">
                        Email Content
                      </label>
                    </div> */}

                    <div
                      className="val-holder"
                      dangerouslySetInnerHTML={{
                        __html: getValue(props, `editInfo.html`, ""),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="compelte-task-wrapper__cta d-flex align-items-center">
              <button
                className="ascent-button ascent-button--primary"
                onClick={() => setShowUpdatePopup(false)}
              >
                Close
              </button>
              {/* <button
                className="ascent-button ascent-button--secondary"
                onClick={() => handleSubmit()}
                disabled={submitLoading}
              >
                {submitLoading
                  ? "Please wait..."
                  : editId
                  ? "Update"
                  : "Create"}
              </button> */}
            </div>
          </div>
          {/* <div style={{ marginLeft: "30px" }}></div> */}
          {/* <div className="user-details-wrapper email-template-non-editable-content-holder flex-1">
            <p className="key-header">Placeholders</p>
            <div className="d-flex keys-container">
              {getValue(props, `keysInfo.keys`, []).map((item: any) => {
                return (
                  <div
                    className="key-title-container"
                    onClick={() => CopyToClipboard(`<%= ${item} %>`)}
                  >
                    <p className="key-title">{item}</p>
                  </div>
                );
              })}
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default EmailLogViewPopup;
